const getTextWidth = (() => {
	const container = document.createElement("canvas");

	return function (inputText?: string | number | null, backupRatio = 0.5): number {
		let width = 0;
		let text = inputText ?? "";
		text = text.toString();

		const context = container.getContext("2d");
		if (context) {
			context.font = window.getComputedStyle(document.body).getPropertyValue("font");
			width = context.measureText(text).width;
			return Math.ceil(width);
		} else {
			const fontSize = parseFloat(window.getComputedStyle(document.body).getPropertyValue("font-size"));
			return Math.ceil(fontSize * backupRatio * text.length);
		}
	};
})();

export default getTextWidth;
